import React from "react";

function HomeEventSkeleton() {
  return (
    <div className="border-lightGray dark:border-matteGray border rounded-xl">
      <div className="w-full h-48 rounded-t-xl border-b border-lightGray dark:border-matteGray   relative">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full">
          <p className="rounded-xl  animate-pulse bg-frescoWhite dark:bg-darkGray h-4 w-36 mx-auto"></p>
          <p className="rounded-xl  animate-pulse bg-frescoWhite dark:bg-darkGray h-5 w-40 mx-auto mt-2"></p>
        </div>
        <div className={`absolute top-3 right-3`}>
          <p className="rounded-full  animate-pulse bg-frescoWhite dark:bg-darkGray h-7 w-7 "></p>
        </div>
      </div>
      <div className="h-44  w-full rounded-b-xl relative">
        <div className="p-4">
          <p className="rounded-xl  animate-pulse bg-frescoWhite dark:bg-darkGray h-5 w-24"></p>
          <div className="flex pt-2 space-x-3">
            <p className="rounded-full  animate-pulse bg-frescoWhite dark:bg-darkGray h-14 w-14 "></p>
            <p className="rounded-full  animate-pulse bg-frescoWhite dark:bg-darkGray h-14 w-14 "></p>
            <p className="rounded-full  animate-pulse bg-frescoWhite dark:bg-darkGray h-14 w-14 "></p>
            <p className="rounded-full  animate-pulse bg-frescoWhite dark:bg-darkGray h-14 w-14 "></p>
            <p className="rounded-full  animate-pulse bg-frescoWhite dark:bg-darkGray h-14 w-14 "></p>
            <p className="rounded-full  animate-pulse bg-frescoWhite dark:bg-darkGray h-14 w-14 "></p>
          </div>
        </div>
        <div className="absolute w-full bottom-0">
          <div className="flex justify-between items-center w-full py-4 px-5">
            <div className="flex items-center -ml-1 pt-2">
              <div className="-space-x-3 flex overflow-hidden ">
                <div className="inline-flex relative overflow-hidden  rounded-full w-10 animate-pulse bg-frescoWhite dark:bg-darkGray h-10"></div>
                <div className="inline-flex relative overflow-hidden  rounded-full w-10 animate-pulse bg-frescoWhite dark:bg-darkGray h-10"></div>
                <div className="inline-flex relative overflow-hidden  rounded-full w-10 animate-pulse bg-frescoWhite dark:bg-darkGray h-10"></div>
              </div>
              <p className="ml-2 rounded-xl  animate-pulse bg-frescoWhite dark:bg-darkGray h-5 w-20"></p>
            </div>
            <div className=" rounded-3xl  animate-pulse bg-frescoWhite dark:bg-darkGray h-9 w-20"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeEventSkeleton;
